import { Stack, Button } from "@mui/material";
import { useWebApiV1OrderQuery } from "@providers/hop-ord-server/api";
import { useNavigate, useParams } from "react-router-dom";
import { UploadPanel } from "../components";
import BottomActionBar from "@pages/Layout/BottomActionBar";
import { OrderStatus } from "@enums";

const PlanReviewPage = () => {
  const { orderId } = useParams();
  const navigate = useNavigate();
  const { data: orderData, isLoading: orderLoading } = useWebApiV1OrderQuery({
    orderId: Number(orderId),
  });

  if (orderLoading) {
    return <></>;
  }

  return (
    <>
      <UploadPanel orderId={Number(orderId)} orderData={orderData} />
      <BottomActionBar>
        <Stack
          direction="row"
          sx={{
            width: 1,
            justifyContent: "flex-end",
            padding: 2,
            gap: 2,
            borderTop: "1px solid",
            borderColor: "divider",
          }}
        >
          <Button
            data-testid="back-to-plan-generation-button"
            variant="outlined"
            color="primary"
            onClick={() => {
              if (orderData?.status === OrderStatus.SUBMITTED) {
                navigate(`/commandcenter/${orderId}`);
              } else {
                navigate(`/commandcenter/${orderId}/automated`);
              }
            }}
          >
            Back: Plan Generation
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={() => navigate(`/commandcenter/${orderId}/handover`)}
          >
            Next: Handover
          </Button>
        </Stack>
      </BottomActionBar>
    </>
  );
};

export default PlanReviewPage;
